import React from 'react';
import Input from 'form/components/Input/Input';
import { FormInput } from 'form/FormInput';
import { ComponentProps } from 'lmc-ui-library/lib/components/atoms/Input/Input.types';

interface Props extends ComponentProps, FormInput {
  wrapperStyle?: React.CSSProperties;
  newUi?: boolean;
}

const TextInput = React.forwardRef<HTMLInputElement, Props>(({ wrapperStyle, ...props }, ref) => {
  return (
    <div style={wrapperStyle}>
      <Input {...props} ref={ref} />
    </div>
  );
});

export default TextInput;
